const handleValidation = (name, value, validStateTemp) => {
  let valid = true;
  if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["maxLength"]) &&
    value.length > validStateTemp[name]["conditions"]["maxLength"]
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] =
      "Maximum " +
      validStateTemp[name]["conditions"]["maxLength"] +
      " characters Allowed.!";
    valid = false;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["minLength"]) &&
    value.length < validStateTemp[name]["conditions"]["minLength"]
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] =
      "Minimum " +
      validStateTemp[name]["conditions"]["minLength"] +
      " characters Required.!";
    valid = true;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["maxWordLength"]) &&
    value.split(validStateTemp[name]["conditions"]["delimiter"] || " ").length >
    validStateTemp[name]["conditions"]["maxWordLength"]
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] =
      "Maximum " +
      validStateTemp[name]["conditions"]["maxWordLength"] +
      " Words Allowed.!";
    valid = false;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["minWordLength"]) &&
    value.split(validStateTemp[name]["conditions"]["delimiter"] || " ").length <
    validStateTemp[name]["conditions"]["minWordLength"]
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] =
      "Minimum " +
      validStateTemp[name]["conditions"]["minWordLength"] +
      " Words Required.!";
    valid = true;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["maxValue"]) &&
    value > validStateTemp[name]["conditions"]["maxValue"]
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] =
      "Maximum allowed value is " +
      validStateTemp[name]["conditions"]["maxValue"] +
      "..!";
    valid = false;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["minValue"]) &&
    value < validStateTemp[name]["conditions"]["minValue"]
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] =
      "Minimum allowed value is " +
      validStateTemp[name]["conditions"]["minValue"] +
      "..!";
    valid = true;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["pattren"]) &&
    value.length > 0 &&
    !validStateTemp[name]["conditions"]["pattren"].test(value)
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] = "Pattren mismatched..!";
    valid = true;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["minDate"]) &&
    new Date(value) < new Date(validStateTemp[name]["conditions"]["minDate"])
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] = "Minimum Date Out of range..!";
    valid = true;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["maxDate"]) &&
    new Date(value) > new Date(validStateTemp[name]["conditions"]["maxDate"])
  ) {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = false;
    validStateTemp[name]["message"] = "Maximum Date  Out of range..!";
    valid = true;
  } else if (
    validStateTemp[name].hasOwnProperty(["conditions"]) &&
    validStateTemp[name]["conditions"].hasOwnProperty(["required"]) &&
    validStateTemp[name]["conditions"]["required"]
  ) {
    if (value === null || value === "") {
      validStateTemp[name]["changed"] = true;
      validStateTemp[name]["valid"] = false;
      validStateTemp[name]["message"] = "This field is required!";
      valid = false;
    } else if (
      validStateTemp[name].conditions["type"] &&
      validStateTemp[name].conditions["type"] === "array"
    ) {
      if (!Array.isArray(value)) {
        validStateTemp[name]["valid"] = false;
        validStateTemp[name]["changed"] = true;
        validStateTemp[name]["message"] = "Pattern mismatched!";
      } else if (value.length === 0) {
        validStateTemp[name]["valid"] = false;
        validStateTemp[name]["changed"] = true;
        validStateTemp[name]["message"] = "This Field is required!";
      } else {
        validStateTemp[name]["changed"] = true;
        validStateTemp[name]["valid"] = true;
        valid = true;
      }
    } else {
      validStateTemp[name]["changed"] = true;
      validStateTemp[name]["valid"] = true;
      valid = true;
    }
  } else if (
    validStateTemp[name]["conditions"].hasOwnProperty("conditionalRequired") &&
    validStateTemp[name]["conditions"].hasOwnProperty("conditionField") &&
    validStateTemp[name]["conditions"].hasOwnProperty("conditionOperator") &&
    validStateTemp[name]["conditions"].hasOwnProperty("conditionValue") &&
    validStateTemp[name]["conditions"]["conditionOperator"] === "eq" &&
    validStateTemp[name]["conditions"]["conditionValue"] ===
    validStateTemp[name]["conditions"]["conditionFieldValue"]
  ) {
    if (value === null || value === "") {
      validStateTemp[name]["changed"] = true;
      validStateTemp[name]["valid"] = false;
      validStateTemp[name]["message"] = "This field is required!";
      valid = false;
    } else {
      validStateTemp[name]["changed"] = true;
      validStateTemp[name]["valid"] = true;
      valid = true;
    }
  } else if (
    validStateTemp[name]["conditions"].hasOwnProperty("conditionalRequired") &&
    validStateTemp[name]["conditions"].hasOwnProperty("conditionField") &&
    validStateTemp[name]["conditions"].hasOwnProperty("conditionOperator") &&
    validStateTemp[name]["conditions"].hasOwnProperty("conditionValue") &&
    validStateTemp[name]["conditions"]["conditionOperator"] === "neq" &&
    validStateTemp[name]["conditions"]["conditionValue"] !==
    validStateTemp[name]["conditions"]["conditionFieldValue"] &&
    validStateTemp[name]["conditions"]["conditionFieldValue"] != ""
  ) {
    if (value === null || value === "") {
      validStateTemp[name]["changed"] = true;
      validStateTemp[name]["valid"] = false;
      validStateTemp[name]["message"] = "This field is required!";
      valid = false;
    } else {
      validStateTemp[name]["changed"] = true;
      validStateTemp[name]["valid"] = true;
      valid = true;
    }
  } else {
    validStateTemp[name]["changed"] = true;
    validStateTemp[name]["valid"] = true;
    valid = true;
  }
  return { validStateTemp: validStateTemp, valid: valid };
};

export default handleValidation;
